import React from 'react'

import { CircularProgress, Grid, Typography } from '@mui/material';

export default function CircularLoader(props) {
  const {
    message = null,
    size = '4em',
    color = 'secondary',
    messageColor = 'inherit',
    typographyVariant = 'h6'
  } = props;

  return (
    <Grid item xs={3} sm={3} sx={{ textAlign: 'center' }}>
      <CircularProgress size={size} color={color} />
      <Typography variant={typographyVariant} color={messageColor}>{message}</Typography>
    </Grid>
  );
}
